<template>
    <div v-if="activeInfo && cptInfo[activeInfo.cpt]">
        <div :class="['infoHolders', { 'infoHolders--mobile': isMobile() }]">
            <!-- <span class="meterInfo">
                <label class="lblInfo">Meter ID: </label>
                {{ activeInfo.meterid }}
            </span>
            <span class="codeInfo">
                <label class="lblInfo">CPT Code: </label>
                {{ activeInfo.cpt }}
            </span>
            <span class="descInfo">
                <label class="lblInfo">Description: </label>
                {{ cptInfo[activeInfo.cpt].desc }}
            </span> -->
            <span class="billingInfo">
                <label class="lblInfo">Billable Amount: </label>
                {{ '$' + activeInfo.cost }}
            </span>
            <template v-if="!activeInfo.firstDate">
                <span class="nullMsg"> No data received yet </span>
            </template>
            <template v-else>
                <span class="viewingInfo">
                    <label class="lblInfo">Date Range: </label>
                    {{ activeInfo.firstDate + ' to ' + activeInfo.lastDate }}
                </span>
                <span class="lastMeasInfo">
                    <label class="lblInfo">Last Measurement: </label>
                    {{ activeInfo.latestDateAdded }}
                </span>
                <span class="statusInfo">
                    <label class="lblInfo">Status: </label>
                    {{ {0:"Not Billable", 1:"Billable", 2:"Billed"}[activeInfo.status] }}
                    <button v-if="activeInfo.status == 1" @click="billCpt()"> Mark Billed </button>
                </span>
                <span class="reqInfo">
                    <label class="lblInfo">Measurements: </label>
                    {{ formatCycleCount(activeInfo.cpt, activeInfo.cycleCount) }}
                </span>
                <div :class="['calendarInfo', { 'calendarInfo--mobile': isMobile() }]">
                    <v-calendar @dayclick="dayClickHandler" :attributes="attr" :columns="columns" :from-date="fromDate"/>
                    <!-- @TODO: Include max-date = new Date() for prod, no use for future dates  -->
                </div>
                <div :class="['cycleButtons', { 'cycleButtons--mobile': isMobile() }]">
                    <span v-if="activeInfo.fidLastCycle" class="lastCycleInfo">
                        <a class="lblInfo" @click="showPrevCycle()">View Previous Cycle</a>
                    </span>
                    <span v-if="activeInfo.fidLastCycle && activeInfo.fidNextCycle"> | </span>
                    <span v-if="activeInfo.fidNextCycle" class="nextCycleInfo">
                        <a class="lblInfo" @click="showNextCycle()">View Next Cycle</a>
                    </span>
                </div>
            </template>
        </div>
    </div>
    <div v-else>
        <span class="nullMsg"> No data </span>
    </div>
</template>
<script>
// import VCalendar from 'v-calendar'
import { mapGetters } from 'vuex';
import axios from 'axios'
import { CURR_API, OTHER_API } from '@/constants/apis'
import cptInfo from '@/data/cptInfo'
export default {
    name: 'cpt-desc',
    data() {
        return {
            cptInfo,
            currentInfoChild: this.currentInfo
        }
    },
    // components: {
    //     'v-calendar': VCalendar
    // },
    props: {
        currentInfo: {},
        historicalInfo: {},
        measurements: { type: Array, default: () => [] },
        cpt: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapGetters('login', {
            allData: 'getAllData'
        }),
        activeInfo() {
            // console.log(this.currentInfo)
            // console.log(this.historicalInfo)
            // console.log(this.measurements)
            return {...this.currentInfoChild}
        },
        columns() {
            if (this.isMobile()) {
                return 1;
            }
            let firstDate = this.currentInfoChild.firstDate.split('-')
            let lastDate = this.currentInfoChild.lastDate.split('-')
            if (firstDate[0] === lastDate[0] && firstDate[1] === lastDate[1])
                return 1
            else
                return 2
        },
        fromDate() {
            let firstDate = new Date(this.currentInfoChild.firstDate)
            return firstDate
        },
        attr() {
            let dots = []
            this.measurements.forEach(meas => {
                let dotDate = {}
                let measDate = new Date(meas.MdateTime)
                dotDate["dot"] = 'red'
                dotDate["dates"] = new Date(measDate.getFullYear(), measDate.getMonth(), measDate.getDate())
                dotDate["popover"] = { label: "" + measDate.toLocaleTimeString() + ": " + meas.MValue1 }
                dots.push(dotDate)
            })
            // let measDateList = []
            // this.measurements.forEach(meas => {
            //     let measDate = new Date(meas.MdateTime)
            //     measDateList.push(new Date(measDate.getFullYear(), measDate.getMonth(), measDate.getDate()))
            // })

            return [
                {
                    highlight: {
                        start: { fillMode: 'outline' },
                        base: { fillMode: 'light' },
                        end: { fillMode: 'outline' },
                    },
                    dates: {
                        start: this.activeInfo.firstDate.replaceAll('-', '/'),
                        end: this.activeInfo.lastDate.replaceAll('-', '/')
                    },
                },
                ...dots
            ]
        }
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
        },
        async billCpt(){
            let content = {
                "PatientCpt": {
                      "API_Meth": "MarkBilled",
                      "fid": this.activeInfo.fid,
                      "current": this.activeInfo.fidNextCycle ? 0 : 1
                  }
            }
            await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
              .then((res) => {
                  if (res.data.status == "Success"){
                    this.currentInfoChild.status = 2
                  }
                  else {
                    alert("Failure with billing. Please contact an administrator.")
                  }
              })
        },
        fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s},
        formatCycleCount(cpt, count){
            let append = ' unique daily recordings'
            if (cpt === '98980' || cpt === '98981' || cpt === '99457' || cpt === '99458'){
                append = ' minutes'
                return `${this.fmtMSS(count)} ${append}`
            }
            return `${count} ${append}`
        },
        showPrevCycle(){
            this.currentInfoChild = this.historicalInfo[this.currentInfoChild.fidLastCycle]
        },
        showNextCycle(){
            this.currentInfoChild = this.historicalInfo[this.currentInfoChild.fidNextCycle]
        },
        dayClickHandler(event){
            let eventDate = new Date(event.id)
            let eventDatePlus30 = new Date(event.id)
            eventDatePlus30 = new Date(eventDatePlus30.setDate(eventDatePlus30.getDate() + 30))
            let event30String = new Date(eventDatePlus30.getTime() - (eventDatePlus30.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
            let today = new Date()
            let timeframe = this.cptInfo[this.cpt].timeframe
            let confirmMsg = timeframe == "30 days" ? `Would you like to create a new cycle from ${event.id} to ${event30String}?` : "Would you like to create a new cycle for this month?"
            if (eventDate <= today && confirm(confirmMsg)) {

                console.log(this.currentInfoChild, this.historicalInfo)
                console.log(timeframe)
            }
        },
    }
}
</script>
<style scoped>
.infoHolders {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    gap: 0.35rem;
}
.infoHolders--mobile {
    font-size: 1rem;
}
.infoHolders--mobile .statusInfo button {
    display: block;
    margin-top: 0.5rem;
    width: 100%;
    max-width: 200px;
    padding: 0.5rem;
}
.lblInfo {
    font-weight: bold;
}
.nullMsg {
    display: block;
    margin: 0;
}
.calendarInfo {
    margin: 0.75rem 0 0;
    font-size: 1rem;
}
.calendarInfo--mobile {
    margin: 0.75rem 0 0;
    font-size: 1rem;
    width: 100%;
    overflow-x: auto;
}
.lastCycleInfo {
    margin: auto;
}
.cycleButtons {
    margin: auto;
}
.cycleButtons--mobile {
    margin: 0.75rem 0 0;
    text-align: center;
    font-size: 0.95rem;
}
</style>